import { render, staticRenderFns } from "./addPassword.vue?vue&type=template&id=a8bdfd7c&scoped=true"
import script from "./addPassword.vue?vue&type=script&lang=js"
export * from "./addPassword.vue?vue&type=script&lang=js"
import style0 from "./addPassword.vue?vue&type=style&index=0&id=a8bdfd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bdfd7c",
  null
  
)

export default component.exports